import { atom } from "jotai";

import { HoleCount } from "@whoosh/design-system/src/components/icons_v2/courseLayout";

import { currentBookingAtom } from "../../stores";

export const setCourseLayoutOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      roundId: string;
      courseLayout: { id: string; holeCount: HoleCount };
      isTargetingAll: boolean;
    }
  ) => {
    const { roundId, courseLayout, isTargetingAll } = payload;
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return;
    const updatedRounds =
      currentBooking?.rounds?.map((round) => {
        if (isTargetingAll || round.localId === roundId) {
          return { ...round, courseLayout };
        }
        return round;
      }) ?? [];
    const newBooking = {
      ...currentBooking,
      rounds: updatedRounds,
    };
    set(currentBookingAtom, newBooking);
  }
);
